import Cookies from "js-cookie";
import HttpConnection from "@/utils/HttpConnection";

export default {
    state: {
        courseLevel: [
            {
                name: "体系",
                mArray: ["基础选课", "信息安全选课", "攻防实训中心"],
                selected: 0
            },
            {
                name: "类别",
                mArray: ["数据库应用", "密码学与应用"],
                selected: 0
            },
            {
                name: "难度",
                mArray: ["初级", "中级", "高级"],
                selected: 0
            }
        ],
        courseLevelIds: {
            architectureId: 0,
            classificationId: 0,
            difficultyId: 0
        }
    },
    mutations: {
        setCourseLevel(state, params) {
            state.courseLevel = params;
        },
        setCourseLevelIds(state, params) {
            state.courseLevelIds = params;
        }
    },
    actions: {
        getLevelList({ commit }, params) {
            let courseLevel = [
                {
                    name: "体系",
                    mArray: ["基础选课", "信息安全选课", "攻防实训中心"],
                    selected: 0
                },
                {
                    name: "类别",
                    mArray: ["数据库应用", "密码学与应用"],
                    selected: 0
                },
                {
                    name: "难度",
                    mArray: ["初级", "中级", "高级"],
                    selected: 0
                }
            ];
            HttpConnection.get("/teach/archit/list", { params: {}}).then(function(architList) { // 体系
                let _mArray = architList.rows;
                courseLevel[0].mArray = _mArray;
                HttpConnection.get("teach/claific/list", { params: {}}).then(function(clifList) { // 类别
                    let _mArray = clifList.rows;
                    courseLevel[1].mArray = _mArray;
                    HttpConnection.get("/teach/difficulty/list", { params: {}}).then(function(difficultyList) { // 难度
                        let _mArray = difficultyList.rows;
                        courseLevel[2].mArray = _mArray;
                        commit("setCourseLevel", courseLevel);
                    }).catch(function(error) {
                        console.log(error);
                    });
                }).catch(function(error) {
                    console.log(error);
                });
            }).catch(function(error) {
                console.log(error);
            });
        }
    }
};
